"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _getNested = _interopRequireDefault(require("../getNested"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var NestedFeature =
/*#__PURE__*/
function (_Component) {
  _inherits(NestedFeature, _Component);

  function NestedFeature(props, context) {
    var _this;

    _classCallCheck(this, NestedFeature);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NestedFeature).call(this, props, context));
    _this.myRef = _react.default.createRef();
    return _this;
  }

  _createClass(NestedFeature, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _get = (0, _getNested.default)("feature._ab", this.props, {}),
          exposureId = _get.exposureId,
          featureId = _get.featureId,
          variationId = _get.variationId;

      var _this$context$abCloud = this.context.abCloudResolver,
          observeFeature = _this$context$abCloud.observeFeature,
          exposureObserver = _this$context$abCloud.exposureObserver; // set up tracking

      if (this.myRef.current) {
        // set up the intersection Observer
        this.unobserve = exposureObserver(this.myRef.current, {
          exposureId: exposureId,
          featureId: featureId,
          variationId: variationId,
          name: "Friendly Name"
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.unobserve) {
        this.unobserve.unobserve();
      }
    }
  }, {
    key: "render",
    value: function render() {
      // We can pass in element (as a string) and the Feature wrapper will make itself into whatever
      // is asked for div, span, p, etc. If we do not pass in anything for this prop, then
      // span will be used by default.
      var Element = this.props.element || "span"; // In addition to optionally passing in the ComponentClass we can also pass in the
      // class name(s) and if they are present we will concatenate them with the tracking className
      // and use that on our tracking component.

      var className = this.props.className ? "".concat(this.props.className, " ").concat((0, _getNested.default)("feature._ab.exposureId", this.props)) : (0, _getNested.default)("feature._ab.exposureId", this.props); // we clone the child element(s) and pass in the first level assignment for the given
      // feature, this could be repeated if there are further nested levels
      // const childrenWithProps = React.Children.map(WrappedComponent, child =>
      //     React.cloneElement(WrappedComponent, this.props.feature.assignment)
      // );

      var _this$props$feature = this.props.feature,
          feature = _this$props$feature === void 0 ? {} : _this$props$feature; // if manualRef ref is set to true then additional props "ref" and "className" will be passed to the child
      // it will then be the responsibility of the child to implement the ref and className to allow for tracking
      // this is an escape hatch for when the default wrapper component causes problems with some DOM rendering/styling
      // for example when working with material-ui Grids

      if (this.props.manualRef) {
        return this.props.children({
          feature: (feature || {}).assignment,
          ref: this.myRef,
          className: className
        });
      } else {
        return _react.default.createElement(Element, {
          onContextMenu: this.handleRightClick,
          className: this.props.className,
          style: this.props.style,
          id: this.props.id
        }, this.props.children({
          feature: (feature || {}).assignment
        }));
      }
    }
  }]);

  return NestedFeature;
}(_react.Component); // ...(Array.isArray(feature.assignment)
//     ? { feature: feature.assignment }
//     : feature.assignment),


_defineProperty(NestedFeature, "contextTypes", {
  abCloudResolver: _propTypes.default.object
});

NestedFeature.propTypes = {
  feature: _propTypes.default.object.isRequired,
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  element: _propTypes.default.string,
  children: _propTypes.default.any,
  id: _propTypes.default.any
};
var _default = NestedFeature;
exports.default = _default;